// @flow

export function encodeAuthentication(id, accessToken) {
  const authString = `${id}:${accessToken}`;
  const encodedString = btoa(authString);
  const returnStr = `Basic ${encodedString}`;
  return returnStr;
}
